var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background h-100 d-flex justify-content-center align-items-center",style:(_vm.backgroundStyle),attrs:{"id":"Hide"}})
}
var staticRenderFns = []

export { render, staticRenderFns }